/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { Trans } from "react-i18next";
import styles from "./Header.module.scss";

interface Props {}
interface State {}

export default class Header extends React.Component<Props, State> {
  render() {
    return (
      <div className={styles.Header}>
        <div className={styles.companyName}>
          <Trans i18nKey={"Common.companyName"}>AccelByte</Trans> <Trans i18nKey={"Document.legal"}>Legal</Trans>
        </div>
      </div>
    );
  }
}
